import { Tooltip, withStyles } from '@material-ui/core';

// Readable info-icon tooltip: solid dark bubble, body-size text, comfortable line length.
// MUI's default is a translucent grey at 10px, which is hard to read for multi-sentence help text.
const InfoTooltip = withStyles({
  tooltip: {
    maxWidth: 300,
    padding: '10px 14px',
    borderRadius: 8,
    backgroundColor: 'var(--neutral-800)',
    color: 'var(--neutral-0)',
    boxShadow: 'var(--shadow-md)',
    fontFamily: `'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif`,
    fontSize: '0.8125rem',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: 'normal',
    textTransform: 'none',
  },
  arrow: {
    color: 'var(--neutral-800)',
  },
})(Tooltip);

export default InfoTooltip;
